import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import {
  ArrowUpIcon,
  ChevronRightIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { ChooseReward } from "./ChooseReward";
import { useEffect, useState } from "react";
import { APIClient } from "../../../../helpers/api_helper";
import { GET_SETTING_BY_NAME } from "../../../../helpers/url_helper";

const apiClient = new APIClient();

export function RewardStory({ myRewards, setIsUsedReward, isUsedReward }) {
  const [open, setOpen] = useState(false);
  const [legendByLevel, setLegendByLevel] = useState("");

  const handleCloseRewardHistory = () => {
    setOpen(false);
  };

  const handleGetLegendRewards = async () => {
    try {
      let currentLevel = localStorage.getItem("level");
      let { data } = await apiClient.get(GET_SETTING_BY_NAME, {
        name: "legend-rewards",
      });
      let value = data?.data?.value;
      let levels = value[0]?.levels;
      let legendByLevel = levels.filter((lvl) => lvl?.level === currentLevel)[0]
        ?.legend;
      setLegendByLevel(legendByLevel);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetLegendRewards();
  }, []);

  return (
    <>
      <div className={"w-full"} onClick={() => setOpen(true)} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="bg-white rounded-2xl p-2 mb-4">
            <div className="flex justify-between">
              <div className="flex gap-2">
                <div className="grid content-center">
                  <div className="grid content-center justify-items-center h-10 w-10 rounded-full cursor-pointer bg-greenLight">
                    <ArrowUpIcon className="text-green w-6 h-auto" />
                  </div>
                </div>

                <div className="grid content-center">
                  <div> {myRewards[0]?.description ?? ""} </div>
                  <div className="text-grayP text-sm">
                    {"Elige tu recompensa"}
                  </div>
                </div>
              </div>
              <div className="grid content-center text-tdark text-sm">
                <ChevronRightIcon className="w-6 h-auto" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed bg-darkBgLight/75 inset-0 transition-opacity duration-200 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed bottom-0 right-0 h-100 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-closed:translate-y-full"
              >
                <div
                  className="relative flex h-full flex-col rounded-t-3xl bg-cover tracking-tight font-walsheim"
                  style={{
                    backgroundImage: `url(${localStorage.getItem("avatar")})`,
                  }}
                >
                  <div className="bg-darkBg h-full rounded-t-3xl opacity-50"></div>
                  <div className="p-4 absolute w-full h-full">
                    <div className="flex justify-end">
                      <div className="flex h-7 items-center">
                        <button
                          type="button"
                          onClick={() => setOpen(false)}
                          className="relative text-white focus:outline-hidden"
                          style={{ cursor: "pointer" }}
                        >
                          <span className="absolute" />
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                        </button>
                      </div>
                    </div>
                    <div className="text-white h-full grid content-end pb-10">
                      {legendByLevel && (
                        <div className="text-sm">{legendByLevel}</div>
                      )}

                      <div>
                        <ChooseReward
                          rewards={myRewards[0]?.rewards ?? []}
                          closeRewardHistory={handleCloseRewardHistory}
                          idHistoryReward={myRewards[0]?.id}
                          setIsUsedReward={setIsUsedReward}
                          isUsedReward={isUsedReward}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
